function Icon({ size = "20", color = "#000000" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 6H2V2.5C2 2.22 2.22 2 2.5 2H6V3H3V6ZM17.5 2H14V3H17V6H18V2.5C18 2.22 17.78 2 17.5 2ZM17 17H14V18H17.5C17.78 18 18 17.78 18 17.5V14H17V17ZM3 14H2V17.5C2 17.78 2.22 18 2.5 18H6V17H3V14ZM10.5 12.45V15H9.5V12.45C8.52 12.25 7.75 11.48 7.55 10.5H5V9.5H7.55C7.75 8.52 8.52 7.75 9.5 7.55V5H10.5V7.55C11.48 7.75 12.25 8.52 12.45 9.5H15V10.5H12.45C12.25 11.48 11.48 12.25 10.5 12.45ZM11.5 10C11.5 9.17 10.83 8.5 10 8.5C9.17 8.5 8.5 9.17 8.5 10C8.5 10.83 9.17 11.5 10 11.5C10.83 11.5 11.5 10.83 11.5 10Z"
        fill={color}
      />
    </svg>
  );
}

export default Icon;
